/** Designs & leads keeps its search and filters in the address (?q=…&source=website&views=not_viewed…), so Back from a
 * lead, a reload or a shared link shows the same list (live test C-leads: they reset to "All"). Unknown values are
 * ignored, as before (live test EX-07: ?views=-1, ?status=nope). */
import type { S } from "../api/client";

export interface LeadFilters {
  q: string;
  source: "all" | S["LeadSource"];
  status: "" | S["DesignStatus"];
  offer: "" | S["QuoteOfferStatus"];
  views: "" | S["LeadViewsFilter"];
  stage: string;
}

const SOURCES = ["website", "dashboard", "import"] as const;
const STATUSES = ["draft", "proposed", "sold", "archived"] as const;
const OFFERS = ["requested", "booking_opened", "updated", "expired", "renewal_requested", "draft"] as const;
const VIEWS = ["viewed", "not_viewed"] as const;

const oneOf = <T extends string>(values: readonly T[], value: string | null): T | null =>
  value && (values as readonly string[]).includes(value) ? (value as T) : null;

export function parseLeadFilters(params: URLSearchParams): LeadFilters {
  return {
    q: (params.get("q") ?? "").slice(0, 200),
    source: oneOf(SOURCES, params.get("source")) ?? "all",
    status: oneOf(STATUSES, params.get("status")) ?? "",
    offer: oneOf(OFFERS, params.get("offer")) ?? "",
    views: oneOf(VIEWS, params.get("views")) ?? "",
    stage: (params.get("stage") ?? "").slice(0, 100),
  };
}

/** The address of these filters: defaults are left out, other parameters kept. */
export function leadFiltersParams(filters: LeadFilters, current: URLSearchParams = new URLSearchParams()): URLSearchParams {
  const out = new URLSearchParams(current);
  const set = (key: string, value: string, empty: string) => (value && value !== empty ? out.set(key, value) : out.delete(key));
  set("q", filters.q, "");
  set("source", filters.source, "all");
  set("status", filters.status, "");
  set("offer", filters.offer, "");
  set("views", filters.views, "");
  set("stage", filters.source === "import" ? filters.stage : "", "");
  return out;
}
